<template>
  <div class="pie-chart" ref="chart" style="width: 100%; height: 100%;"></div>
</template>

<script>
export default {
  name: 'PieChart',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    data: {
      handler() {
        this.updateChart()
      },
      deep: true
    }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$refs.chart)
      this.updateChart()
    },
    updateChart() {
      if (!this.chart) return
      
      const option = {
        color: ['#3D76F9', '#9081F8', '#64C5FF', '#FF9F40', '#4BC0C0'],
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'horizontal',
          bottom: '5%',
          left: 'center',
          icon: 'rect',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 20,
          textStyle: {
            fontSize: 14,
            color: '#333'
          }
        },
        series: [
          {
            type: 'pie',
            radius: '65%',
            center: ['50%', '45%'],
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              position: 'inner',
              formatter: '{d}%',
              color: '#fff',
              fontSize: 14,
              fontWeight: 'bold'
            },
            labelLine: {
              show: false
            },
            data: this.data
          }
        ]
      }
      this.chart.setOption(option)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style scoped>
.pie-chart {
  width: 100%;
  height: 100%;
  min-height: 250px;
}
</style>
